
const APP_ID = 'TVOЁ_debug';
const APP_NAME = 'TVOЁ';
const APP_URL = 'https://tv.tvoe.live?installed=vidaa';

const installNewApp = (preview, setDownloadStatus) => {


  if (typeof window.Hisense_installApp !== 'function') {
    setDownloadStatus('Impossible');
    return;
  }

  window.Hisense_installApp(
    APP_ID,
    APP_NAME,
    preview,
    preview,
    preview,
    APP_URL,
    'store',
    (res) => {
      if (res === 0) {
        setDownloadStatus('Success');
      } else {
        setDownloadStatus('Impossible');
      }
    }
  );
};

export default installNewApp;
